<template>
  <div class="contact-wrapper" v-if="restaurant">

    <div class="ct-contact-map-wrapper">
      <div id="contactPageMap" class="ct-contact-map"
           :data-lat="restaurant.locationLatitude"
           :data-lng="restaurant.locationLongitude"></div>
      <a :href="'https://maps.google.com/?q=' + restaurant.locationLatitude + ',' + restaurant.locationLongitude"
         target="_blank" class="btn-custom shadow-none">
        {{ $t('View in Google Maps') }}</a>
    </div>

    <div class="">
      <div class="section section-padding">
        <div class="container">

          <div class="contact-info">

            <div class="row">
              <div class="col-xl-6">
                <div class="ct-info-box">
                  <i class="flaticon-location"></i>
                  <h5>{{ $t('Find Us') }}</h5>
                  <span>{{ restaurant.name }}</span>
                  <span>{{ restaurant.address }}</span>
                  <span>{{ restaurant.zip }} {{ restaurant.city }}</span>
                  <span>
                    <phone-number :number="restaurant.phoneNumber" :show-icon="true"></phone-number>
                  </span>
                  <phone-number v-if="restaurant.additionalPhoneNumber"
                                :number="restaurant.additionalPhoneNumber" :show-icon="false"></phone-number>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="ct-info-box">
                  <i class="flaticon-online-booking"></i>
                  <h5 class="widget-title">{{ $t('Opening Hours') }}</h5>
                  <p>
                          <span>
                            <span>
                              {{ $t('Monday') }}:
                            </span>
                            {{ restaurant.openingHours.monday.hours[0] }}
                          </span>
                    <br/>
                    <span>
                            <span>
                              {{ $t('Tuesday') }}:
                            </span>
                            {{ restaurant.openingHours.tuesday.hours[0] }}
                          </span>
                    <br/>
                    <span>
                            <span>
                              {{ $t('Wednesday') }}:
                            </span>
                            {{ restaurant.openingHours.wednesday.hours[0] }}
                          </span>
                    <br/>
                    <span>
                            <span>
                              {{ $t('Thursday') }}:
                            </span>
                            {{ restaurant.openingHours.thursday.hours[0] }}
                          </span>
                    <br/>
                    <span>
                            <span>
                              {{ $t('Friday') }}:
                            </span>
                            {{ restaurant.openingHours.friday.hours[0] }}
                          </span>
                    <br/>
                    <span>
                            <span>
                              {{ $t('Saturday') }}:
                            </span>
                            {{ restaurant.openingHours.saturday.hours[0] }}
                          </span>
                    <br/>
                    <span>
                            <span>
                              {{ $t('Sunday') }}:
                            </span>
                            {{ restaurant.openingHours.sunday.hours[0] }}
                          </span>
                  </p>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>

  </div>
</template>
<script>
import PhoneNumber from "@/views/partials/PhoneNumber";

export default {
  name: 'Contact',
  components: {PhoneNumber},
  data() {
    return {
      config: window.config,
      restaurant: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.restaurant = this.config.restaurants[0];
    });
  }
}
</script>